//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ILike2BuyModalsState } from '@instagram-account/redux/like2buy/modals/like2buyModalsModel';
import Cuid from '@models/Cuid';
import { SliceNames } from '@redux/SliceNames';
import { IMlsMediaItem } from '@models/IMlsMediaItem';

const initialState: ILike2BuyModalsState = {
  isHideMediaModalOpen: false,
  isDeleteMediaModalOpen: false,
  selectedLike2BuyItemCuids: [],
  isDuplicateItemsModalOpen: false,
  duplicateItems: [],
  addedItemsCount: 0,
};

const { actions, reducer } = createSlice({
  name: SliceNames.Like2BuyModerationModals,
  initialState,
  reducers: {
    openHideFromLike2BuyModal(state, action: PayloadAction<Cuid[]>) {
      state.isHideMediaModalOpen = true;
      state.selectedLike2BuyItemCuids = action.payload;
    },
    closeHideFromLike2BuyModal(state) {
      state.isHideMediaModalOpen = false;
      state.selectedLike2BuyItemCuids = initialState.selectedLike2BuyItemCuids;
    },
    openDeleteFromLike2BuyModal(state, action: PayloadAction<Cuid[]>) {
      state.isDeleteMediaModalOpen = true;
      state.selectedLike2BuyItemCuids = action.payload;
    },
    closeDeleteFromLike2BuyModal(state) {
      state.isDeleteMediaModalOpen = false;
      state.selectedLike2BuyItemCuids = initialState.selectedLike2BuyItemCuids;
    },
    openDuplicateItemsModal(
      state,
      action: PayloadAction<{
        alreadyAddedItems: IMlsMediaItem[];
        addedItemsCount: number;
      }>,
    ) {
      state.isDuplicateItemsModalOpen = true;
      state.duplicateItems = action.payload.alreadyAddedItems;
      state.addedItemsCount = action.payload.addedItemsCount;
    },
    closeDuplicateItemsModal(state) {
      state.isDuplicateItemsModalOpen = false;
      state.duplicateItems = initialState.duplicateItems;
    },
  },
});

export const {
  openHideFromLike2BuyModal,
  closeHideFromLike2BuyModal,
  openDeleteFromLike2BuyModal,
  closeDeleteFromLike2BuyModal,
  openDuplicateItemsModal,
  closeDuplicateItemsModal,
} = actions;

export default reducer;
